import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { TextField } from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import { HttpService } from "../../service/HttpService";
import SearchSelection from "../SelectInput/SearchSelection";

const EditPlantMappingModal = ({
  open,
  onClose,
  data,
  onSubmit,
  saving = false,
}) => {
  const [cloneId, setCloneId] = useState("");
  const [cloneOptions, setCloneOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const httpService = new HttpService();

  useEffect(() => {
    if (open && data) {
      setCloneId(data.clone_id || "");
      fetchCloneIds();
    }
  }, [open, data]);

  const fetchCloneIds = async () => {
    if (!data?.room_id || !data?.epicenter || !data?.bucket_id) return;

    setLoading(true);
    try {
      const response = await httpService.get(
        // `mapping/clone-ids/by-room?room_id=${data.room_id}&epicenter=${data.epicenter}&bucket_id=${data.bucketid}`,
        `mapping/clone-ids/by-room?clone_id=${data.cloneid}`,
      );
      setCloneOptions(response?.data || []);
    } catch (error) {
      console.error("Error fetching clone IDs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="modal_block" style={{ maxWidth: 520, width: "90vw" }}>
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title">Edit Plant Mapping</h2>
          </div>
          <div className="cancel-btn-wrap">
            <RxCross1 onClick={onClose} />
          </div>
        </div>

        <div className="modal_content">
          <div className="form_field_wrapper">
            <label>Epicenter</label>
            <TextField
              fullWidth
              size="small"
              value={data?.epicenter || ""}
              disabled
            />
          </div>

          <div className="form_field_wrapper">
            <label>Bucket ID</label>
            <TextField
              fullWidth
              size="small"
              value={data?.bucket_id || ""}
              disabled
            />
          </div>

          <div className="form_field_wrapper">
            <label>METRC ID</label>
            <TextField
              fullWidth
              size="small"
              value={data?.metrc_id || ""}
              disabled
            />
          </div>

          {/* <div className="form_field_wrapper">
            <label>Clone ID</label>
            <TextField
              fullWidth
              size="small"
              value={cloneId}
              onChange={(e) => setCloneId(e.target.value)}
            />
          </div> */}

          <SearchSelection
            label="Clone ID"
            value={cloneId}
            options={cloneOptions}
            onChange={setCloneId}
            loading={loading}
          />
        </div>

        <div className="modal_footer">
          <button onClick={onClose} className="btn btn-border">
            Cancel
          </button>
          <button
            onClick={() => onSubmit({ clone_id: cloneId })}
            className="btn btn-primary"
            disabled={saving || !cloneId?.id}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditPlantMappingModal;
